import React, { useEffect } from "react";
import { OptimizelyPage } from "./pages/OptimizelyPage/OptimizelyPage";
import { getContentWithChildren } from "../../api/contentDeliveryApi";
import { OptimizelyExpandedValue } from "./types/optimizely/expanded";
import { useQuery } from "@tanstack/react-query";

export const Redesign = ({ pageId }: { pageId: string }) => {
    const content = useQuery<OptimizelyExpandedValue>(['content'], () => getContentWithChildren(pageId));
    
    if (!content) {
        return null;
    }

    return (
        <div className="bg-neutralYellow">
            <OptimizelyPage currentPage={content.data} />
        </div>
    );
}